module.exports = __webpack_public_path__ + "media/video-poster/poster-tablet-f9274c93.jpg";